<template>
  <IonRefresher
    v-if="IsNativePlatform && !IsAppFullscreen"
    slot="fixed"
    mode="md"
    :pullFactor="0.5"
    :pullMin="150"
    @ionRefresh="handleAppReload"
  >
    <IonRefresherContent />
  </IonRefresher>
</template>

<script lang="ts">
import { useAppSettingsStore } from "@/stores/core/appSettingsStore";
import { IonRefresher, IonRefresherContent } from "@ionic/vue";
import { storeToRefs } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppPullToRefresh",
  components: { IonRefresher, IonRefresherContent },
  setup() {
    const appSettingsStore = useAppSettingsStore();
    const { IsNativePlatform, IsAppFullscreen } = storeToRefs(appSettingsStore);
    const { handleAppReload } = appSettingsStore;
    return { IsNativePlatform, IsAppFullscreen, handleAppReload };
  },
});
</script>
